import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-arrow.tsx
/**
* icon.16.arrow
*
* Keywords: diagonal, upward, northeast, ascending, direction, navigation, outward, external
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNyAzLjVhLjUuNSAwIDAgMSAuNS0uNWg1YS41LjUgMCAwIDEgLjUuNXY1YS41LjUgMCAwIDEtMSAwVjQuNzA3bC04LjE0NiA4LjE0N2EuNS41IDAgMCAxLS43MDgtLjcwOEwxMS4yOTMgNEg3LjVhLjUuNSAwIDAgMS0uNS0uNSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-12485
*/
const Icon16Arrow = memo(function Icon16Arrow(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7 3.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V4.707l-8.146 8.147a.5.5 0 0 1-.708-.708L11.293 4H7.5a.5.5 0 0 1-.5-.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Arrow };

//# sourceMappingURL=icon-16-arrow.js.map